import { stringFromPrefixedString } from "../utils";
import { Schema as S } from "effect";
import * as SubscriptionEnvironment from "./SubscriptionEnvironment";
import * as SubscriptionId from "./SubscriptionId";
import * as SubscriptionProvider from "./SubscriptionProvider";
// A qualified subscription or one-time purchase id extends QualifiedSubscriptionId
// with a boolean flag to indicate if it's a one-time purchase
export const Schema = S.Struct({
    id: SubscriptionId.Schema,
    provider: SubscriptionProvider.Schema,
    env: SubscriptionEnvironment.Schema,
    isOneTimePurchase: S.Boolean
});
export const FromString = stringFromPrefixedString("sw_sub_or_otp_", S.compose(S.StringFromBase64Url, S.parseJson(Schema)));
export const Type = Schema.Type;
export const makeUnsafe = ({ id, provider, env, isOneTimePurchase = false })=>({
        id,
        provider,
        env,
        isOneTimePurchase
    });
export const make = ({ id, provider, env, isOneTimePurchase = false })=>S.decodeUnknown(Schema)({
        id,
        provider,
        env,
        isOneTimePurchase
    });
// Helper to convert from QualifiedSubscriptionId
export const fromQualifiedSubscriptionId = (qualifiedSubscriptionId, isOneTimePurchase = false)=>makeUnsafe({
        ...qualifiedSubscriptionId,
        isOneTimePurchase
    });
